import Component from './InstagramAnalyticsPublicHeader.vue'
export default Component
